export default __webpack_public_path__ + "static/media/docdwd.3a30a7ea.svg";